import { render, staticRenderFns } from "./SettingsSidemenu.vue?vue&type=template&id=0e0ef203&scoped=true&"
import script from "./SettingsSidemenu.vue?vue&type=script&lang=js&"
export * from "./SettingsSidemenu.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSidemenu.vue?vue&type=style&index=0&id=0e0ef203&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0ef203",
  null
  
)

export default component.exports